import React, { useState } from 'react';
import { FloorPlanBuilder } from './FloorPlanBuilder';
import { StallPricingConfig } from './StallPricingConfig';
import { VisitorPricingConfig } from './VisitorPricingConfig';
import {
  Layers,
  Building2,
  Ticket,
  Sliders,
  ChevronRight,
  Sparkles,
} from 'lucide-react';

interface AdminConfigModuleProps {
  adminKey: string;
}

export function AdminConfigModule({ adminKey }: AdminConfigModuleProps) {
  const [configTab, setConfigTab] = useState<'layout' | 'stall-pricing' | 'visitor-pricing'>('layout');

  return (
    <div className="space-y-6 animate-in fade-in duration-200">
      {/* Sub-tab Navigation */}
      <div className="flex items-center gap-2 border-b border-slate-200 pb-3 overflow-x-auto scrollbar-thin">
        <button
          type="button"
          onClick={() => setConfigTab('layout')}
          className={`flex items-center gap-2 px-4 py-2.5 rounded-xl text-xs font-bold transition-all shrink-0 cursor-pointer ${
            configTab === 'layout'
              ? 'bg-[#0A3D27] text-white shadow-sm shadow-[#0A3D27]/20'
              : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100'
          }`}
        >
          <Layers className="w-4 h-4" />
          <span>1. Floor Plan & Layout Builder</span>
        </button>

        <button
          type="button"
          onClick={() => setConfigTab('stall-pricing')}
          className={`flex items-center gap-2 px-4 py-2.5 rounded-xl text-xs font-bold transition-all shrink-0 cursor-pointer ${
            configTab === 'stall-pricing'
              ? 'bg-[#0A3D27] text-white shadow-sm shadow-[#0A3D27]/20'
              : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100'
          }`}
        >
          <Building2 className="w-4 h-4" />
          <span>2. Stall Pricing & Categories</span>
        </button>

        <button
          type="button"
          onClick={() => setConfigTab('visitor-pricing')}
          className={`flex items-center gap-2 px-4 py-2.5 rounded-xl text-xs font-bold transition-all shrink-0 cursor-pointer ${
            configTab === 'visitor-pricing'
              ? 'bg-[#0A3D27] text-white shadow-sm shadow-[#0A3D27]/20'
              : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100'
          }`}
        >
          <Ticket className="w-4 h-4" />
          <span>3. Visitor & Delegate Pricing</span>
        </button>
      </div>

      {/* Render Active Sub-section */}
      {configTab === 'layout' && <FloorPlanBuilder adminKey={adminKey} />}
      {configTab === 'stall-pricing' && <StallPricingConfig adminKey={adminKey} />}
      {configTab === 'visitor-pricing' && <VisitorPricingConfig adminKey={adminKey} />}
    </div>
  );
}
